import { render, staticRenderFns } from "./ImageCard.vue?vue&type=template&id=0cd74634"
import script from "./ImageCard.vue?vue&type=script&lang=js"
export * from "./ImageCard.vue?vue&type=script&lang=js"
import style0 from "./ImageCard.vue?vue&type=style&index=0&id=0cd74634&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports